<template>
  <div>
    <p class="tracking-[-0.64px] uppercase font-mono text-brand-green leading-[86.5%] font-medium">
      newsletter
    </p>

    <p class="font-semibold text-3xl lg:text-[64px] tracking-[-2.56px] mt-4 leading-[86.5%]">Chci být v obraze</p>

    <p class="text-[#6E7D78] mt-5 max-w-[530px] text-base lg:text-lg font-medium font-['Inter'] leading-7">Zanechte nám váš e-mail a my vám dáme vědět, když se bude dít něco důležitého.</p>

      <form class="my-6" method="POST" action="https://shopsyscz.ecomailapp.cz/public/subscribe/20/85f7dba955e715936a175d446bc6f115">
        <div class="max-w-[340px] h-[55px] flex">
          <input class="bg-[#0a1713] focus:outline-none focus:ring-1 focus:ring-brand-green/40 px-3 w-full border-0 ring-1 ring-inset ring-[#454f4c]" type="email" name="email" required
            placeholder="Váš e-mail">

          <button class="border group flex justify-center items-center w-[85px] transition-all duration-200 ease-out hover:shadow-green border-[#9EFC4E]" type="submit">

            <svg class="group-hover:translate-x-0 transition-all duration-150 ease-out" width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.2071 8.20711C21.5976 7.81658 21.5976 7.18342 21.2071 6.7929L14.8431 0.428933C14.4526 0.038409 13.8195 0.038409 13.4289 0.428933C13.0384 0.819458 13.0384 1.45262 13.4289 1.84315L19.0858 7.5L13.4289 13.1569C13.0384 13.5474 13.0384 14.1805 13.4289 14.5711C13.8195 14.9616 14.4526 14.9616 14.8431 14.5711L21.2071 8.20711ZM0.5 8.5L20.5 8.5L20.5 6.5L0.5 6.5L0.5 8.5Z"
                fill="#9EFC4E" />
            </svg>
          </button>
      </div>
    </form>
  </div>
</template>

<script>
</script>

<style></style>
